export const ALIGN_ITEMS_CLASSES = {
    'flex-start': 'items-start',
    'flex-end': 'items-end',
    center: 'items-center',
    baseline: 'items-baseline',
    stretch: 'items-stretch',
    normal: '[align-items:normal]',
    start: '[align-items:start]',
    end: '[align-items:end]',
    'first baseline': '[align-items:first_baseline]',
    'last baseline': '[align-items:last_baseline]',
};
export const applyAlignItems = (alignItems) => [
    ...(alignItems ? [ALIGN_ITEMS_CLASSES[alignItems]] : []),
];
